import { render, staticRenderFns } from "./AddressContextMenu.vue?vue&type=template&id=e71c2458&"
import script from "./AddressContextMenu.vue?vue&type=script&lang=ts&"
export * from "./AddressContextMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e71c2458')) {
      api.createRecord('e71c2458', component.options)
    } else {
      api.reload('e71c2458', component.options)
    }
    module.hot.accept("./AddressContextMenu.vue?vue&type=template&id=e71c2458&", function () {
      api.rerender('e71c2458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AddressContextMenu.vue"
export default component.exports